import type { EnrichmentSettings } from '../../../lib/enrichment/api';

interface Props {
  settings: EnrichmentSettings;
  onPatch: (updates: Partial<EnrichmentSettings>) => Promise<EnrichmentSettings | null>;
}

const SOURCES: Array<{
  key: keyof EnrichmentSettings;
  label: string;
  description: string;
  recommendation: 'on' | 'off';
}> = [
  {
    key: 'source_meta_lead_ads_enabled',
    label: 'Meta Lead Ads',
    description: 'Lead Facebook/Instagram raccolti via campagne lead-gen. Trigger automatico al webhook.',
    recommendation: 'on',
  },
  {
    key: 'source_public_form_enabled',
    label: 'Form pubblico',
    description: 'Lead da form Flusia (URL /f/...). Trigger al submit.',
    recommendation: 'on',
  },
  {
    key: 'source_whatsapp_inbound_enabled',
    label: 'WhatsApp inbound',
    description: 'Nuovi lead da numeri sconosciuti che ti scrivono in chat WA.',
    recommendation: 'on',
  },
  {
    key: 'source_external_api_enabled',
    label: 'API esterna',
    description: 'Lead inviati via REST API dal tuo backend o da integrazioni custom.',
    recommendation: 'on',
  },
  {
    key: 'source_csv_import_enabled',
    label: 'Import CSV bulk',
    description: '5000 lead = 5000 crediti potenziali. Default OFF per evitare consumo accidentale.',
    recommendation: 'off',
  },
];

export function EnrichmentSourcesTab({ settings, onPatch }: Props) {
  return (
    <div className="text-[#37352f]">
      <p className="text-[13px] text-[#787774] mb-4">
        Sorgenti disabilitate non bloccano il salvataggio dei lead, semplicemente non scatenano
        arricchimento. Puoi sempre rilanciare manualmente dalla scheda.
      </p>

      <div className="divide-y divide-[rgba(55,53,47,0.09)] border border-[rgba(55,53,47,0.09)] rounded-md">
        {SOURCES.map((s) => {
          const enabled = settings[s.key] as boolean;
          return (
            <div key={s.key as string} className="flex items-start gap-3 px-3 py-3">
              <button
                onClick={() => onPatch({ [s.key]: !enabled } as Partial<EnrichmentSettings>)}
                className={`mt-0.5 relative inline-flex w-9 h-5 rounded-full transition-colors shrink-0 ${
                  enabled ? 'bg-[#37352f]' : 'bg-[rgba(55,53,47,0.16)]'
                }`}
                aria-label="toggle"
              >
                <span
                  className={`absolute top-0.5 left-0.5 w-4 h-4 rounded-full bg-white transition-transform ${
                    enabled ? 'translate-x-4' : ''
                  }`}
                />
              </button>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-2 flex-wrap">
                  <span className="text-[13px] font-medium">{s.label}</span>
                  {s.recommendation === 'off' && (
                    <span className="text-[11px] text-[#cb912f]">· consigliato OFF</span>
                  )}
                </div>
                <p className="text-[12px] text-[#787774] mt-0.5">{s.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
